export default __webpack_public_path__ + "static/media/frame2b.0f3dbbad.PNG";